// M004-F0748 (WebUI #188): the reviewer client over Core's generic relay (CSLPT), the envelopeApi.js shape (design section 9).
// Every operation is POST /api/v1/orgs/:orgId/modules/ledger/messages { relay_version: 1, type, payload }; the answer is
// response.data.data.payload (Booking Keeper frame, unwrapped by Core unread; M001-D034) returned as { ...response, data: { success: true, data } }.
// queue / review are keyed by state / transaction_id; return / approve / history are keyed as the design table says
// (return and approve by envelope_id - the queue row carries it; history by transaction_id). No reviewer write carries an Idempotency-Key:
// the Ledger answers a repeat with ENVELOPE_STATE_INVALID, which the drawer shows verbatim with its code.
// No receipt image read: Core has no claim-scoped image route yet (Core #402), and the UI never calls a route the backend lacks (api-contract gate).
import api from './api';

const orgSegment = (orgId) => encodeURIComponent(orgId);
const messagesPath = (orgId) => `/v1/orgs/${orgSegment(orgId)}/modules/ledger/messages`;
const send = async (orgId, type, payload) => {
  const response = await api.post(messagesPath(orgId), { relay_version: 1, type, payload });
  return { ...response, data: { success: true, data: response?.data?.data?.payload } };
};

export const claimReviewApi = {
  queue: (orgId, state) => send(orgId, 'envelope.claim.queue', state ? { state } : {}),
  review: (orgId, transactionId) => send(orgId, 'envelope.claim.review', { transaction_id: transactionId }),
  history: (orgId, transactionId) => send(orgId, 'envelope.claim.history', { transaction_id: transactionId }),
  returnClaim: (orgId, envelopeId, reason) => send(orgId, 'envelope.claim.return', { envelope_id: envelopeId, reason }),
  approve: (orgId, envelopeId) => send(orgId, 'envelope.claim.approve', { envelope_id: envelopeId }),

};
